import { render, staticRenderFns } from "./areas.vue?vue&type=template&id=11e71102&scoped=true"
import script from "./areas.vue?vue&type=script&lang=js"
export * from "./areas.vue?vue&type=script&lang=js"
import style0 from "./areas.vue?vue&type=style&index=0&id=11e71102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e71102",
  null
  
)

export default component.exports